import { render, staticRenderFns } from "./CraftCalculatorView.vue?vue&type=template&id=1fc13a9e&scoped=true&"
import script from "./CraftCalculatorView.vue?vue&type=script&lang=ts&"
export * from "./CraftCalculatorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc13a9e",
  null
  
)

export default component.exports